import { CopyableContent } from "@/src/components/copyable-content";
import { useComparison } from "@/src/context/comparison-text";
import { getDisplayValue, compareStrings, FieldType } from "@/src/lib/utils/string-utils";

interface ComparisonFieldProps {
  label: string;
  value: string;
  secondaryValue: string;
  type?: FieldType;
  compareAgainstTitle?: string;
}

export function ComparisonField({
  label,
  value,
  secondaryValue,
  type = "text",
  compareAgainstTitle = "EMR",
}: ComparisonFieldProps) {
  const context = useComparison();

  if (context?.comparisonLabel) {
    compareAgainstTitle = context.comparisonLabel;
  }

  // Format values for display using centralized helper
  const formattedValue = getDisplayValue(value, type);
  const formattedSecondaryValue = getDisplayValue(secondaryValue, type);

  // Use raw values for comparison logic
  const hasConflict = !compareStrings(value, secondaryValue, type);

  return (
    <div>
      <span className="font-medium">{label}:</span>{" "}
      <span>
        <CopyableContent text={formattedValue} textClassName={`${hasConflict ? "bg-warn/20" : "text-foreground"}`} />
      </span>
      {hasConflict && (
        <div className="text-xs text-muted-foreground mt-1">
          <span className="text-warn dark:text-warn">
            {compareAgainstTitle}:{" "}
            <CopyableContent text={formattedSecondaryValue} textClassName="text-warn dark:text-warn" />
          </span>
        </div>
      )}
    </div>
  );
}
